/**
 * Sesión del superadmin. El token vive en localStorage (`turnlinkToken`, la misma
 * llave que usan los servicios para el header Authorization) y se valida decodificando
 * el JWT: rol `superadmin` y no expirado. Así la sesión sobrevive recargas sin
 * depender de banderas sueltas como el viejo `isAdminLogged`.
 */
const TOKEN_KEY = 'turnlinkToken';

function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function getSuperadminSession() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  if (!payload || payload.role !== 'superadmin') return null;
  if (payload.exp && payload.exp * 1000 <= Date.now()) {
    clearSuperadminSession();
    return null;
  }
  return { token, expiresAt: payload.exp ? payload.exp * 1000 : null };
}

export function saveSuperadminSession(token) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem('isAdminLogged'); // bandera legacy de la landing
}

export function clearSuperadminSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('isAdminLogged');
}

export function superadminAuthHeaders() {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
}
